module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3_en.468421f6b0248e628fcb3990ef613ea4.png";